export const getClearRequestId = requestId => {
  return requestId.split(',').map(x => x.trim()).filter(Boolean).at(0);
};
//# sourceMappingURL=getClearRequestId.js.map